var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 0C8.07538 0 4.85938 3.2064 4.85938 7.11984C4.85938 8.63616 5.3437 10.0454 6.1633 11.2037L11.1282 19.7868C11.8235 20.6952 12.2857 20.5226 12.8639 19.7388L18.3402 10.4196C18.4506 10.2194 18.5375 10.0063 18.6131 9.78864C18.9604 8.94176 19.1391 8.0352 19.1391 7.11984C19.1394 3.2064 15.9243 0 11.9996 0ZM11.9996 3.336C14.1131 3.336 15.7935 5.01264 15.7935 7.11984C15.7935 9.22704 14.1131 10.9032 11.9996 10.9032C9.88642 10.9032 8.20522 9.22752 8.20522 7.12008C8.20522 5.01264 9.88642 3.33624 11.9994 3.33624",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5376 11.7344L16.526 11.7646L16.5361 11.737L16.5376 11.7344ZM8.15988 16.5701C4.76964 17.0492 2.39844 18.1952 2.39844 19.8821C2.39844 22.1545 6.36036 23.9965 11.9984 23.9965C17.6365 23.9965 21.5984 22.1545 21.5984 19.8821C21.5984 18.1952 19.2275 17.0492 15.8375 16.5701L15.3678 17.3698C17.9228 17.7243 19.6784 18.4693 19.6784 19.3337C19.6784 20.5457 16.24 21.5281 11.9984 21.5281C7.75692 21.5281 4.31844 20.5457 4.31844 19.3337C4.3182 18.4721 6.06228 17.7279 8.62524 17.372L8.15988 16.5701Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPoi);
export default __webpack_public_path__ + "static/media/location-poi.525f66acbaeca14ef1c51c1544c96394.svg";
export { ForwardRef as ReactComponent };